import React from "react";
import { Button } from "@/components/ui/button";
import { Textarea } from "@/components/ui/textarea";
import { Card } from "@/components/ui/card";
import { CheckCircle2, XCircle, Loader2 } from "lucide-react";

export default function ReviewActionBar({
  onApprove,
  onReject,
  approveComment,
  onApproveCommentChange,
  rejectReason,
  onRejectReasonChange,
  busy = false,
  className,
}) {
  return (
    <Card className={`p-6 border-border${className ? ` ${className}` : ""}`}>
      <div className="text-[10px] uppercase tracking-[0.18em] text-muted-foreground font-bold">
        Decision
      </div>
      <Textarea
        value={approveComment}
        onChange={onApproveCommentChange}
        placeholder="Approval comment (optional)…"
        className="mt-3 min-h-[70px]"
        data-testid="approve-comment"
      />
      <div className="mt-3 flex flex-wrap justify-end gap-2">
        <Textarea
          value={rejectReason}
          onChange={onRejectReasonChange}
          placeholder="Reject reason (required to reject)"
          className="flex-1 min-h-[40px]"
          data-testid="reject-reason"
        />
        <Button
          variant="outline"
          onClick={onReject}
          disabled={busy || !rejectReason?.trim()}
          data-testid="reject-btn"
        >
          <XCircle className="h-4 w-4 mr-1.5" />Reject
        </Button>
        <Button
          onClick={onApprove}
          disabled={busy}
          data-testid="approve-btn"
        >
          {busy
            ? <Loader2 className="h-4 w-4 animate-spin" />
            : <CheckCircle2 className="h-4 w-4 mr-1.5" />}
          Approve &amp; release
        </Button>
      </div>
    </Card>
  );
}
